import { BaseAPIModel } from '@weezevent/weezjs-core';

export class LegalEntity extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl() {
        return `/ticket/accounting/legal_entity`;
    }

    toOption() {
        return {
            text: this.name,
            value: this.uuid,
            key: this.uuid
        };
    }
}
